var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDvsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SMALL_DVS_Check",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #SMALL_DVS_Check .cls-1 {\n        fill: #00c4ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1156.94 -343.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_567",
    "data-name": "Pfad 567",
    className: "cls-1",
    d: "M1176.94,383.825a20,20,0,1,1,20-20A20.022,20.022,0,0,1,1176.94,383.825Zm0-37.849a17.849,17.849,0,1,0,17.849,17.849A17.87,17.87,0,0,0,1176.94,345.976Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_568",
    "data-name": "Pfad 568",
    className: "cls-1",
    d: "M1183.752,363.428a9.339,9.339,0,0,0-7.417-3.591h-.116a7.641,7.641,0,0,0-6.841,3.637l-.113.216.129.207a8.24,8.24,0,0,0,6.763,3.611c.06,0,.121,0,.182,0a10.39,10.39,0,0,0,7.4-3.566l.2-.249Zm-7.4,3.086a2.842,2.842,0,1,1,2.843-2.843A2.846,2.846,0,0,1,1176.355,366.514Zm-6.093-2.859a6.688,6.688,0,0,1,4.125-2.766,3.4,3.4,0,0,0-.031,5.542A7.531,7.531,0,0,1,1170.262,363.655Zm8.255,2.653a3.4,3.4,0,0,0-.1-5.349,8.719,8.719,0,0,1,4.429,2.695A10.169,10.169,0,0,1,1178.517,366.308Z",
    transform: "translate(-2.641 -2.817)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    className: "cls-1",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(1171.901 359.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_569",
    "data-name": "Pfad 569",
    className: "cls-1",
    d: "M1176.5,374.28a10.512,10.512,0,1,1,10.513-10.512A10.525,10.525,0,0,1,1176.5,374.28Zm0-19.525a9.012,9.012,0,1,0,9.013,9.013A9.024,9.024,0,0,0,1176.5,354.755Z",
    transform: "translate(-2.494 -2.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_570",
    "data-name": "Pfad 570",
    className: "cls-1",
    d: "M1190.639,379.846a1.5,1.5,0,0,1-1.061-.44l-4.964-4.963a1.5,1.5,0,0,1,2.121-2.121l4.964,4.963a1.5,1.5,0,0,1-1.06,2.561Z",
    transform: "translate(-4.011 -4.167)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvsCheck);
export default __webpack_public_path__ + "static/media/dvs-check.d931ce6c52932b1283c63af7aec226e3.svg";
export { ForwardRef as ReactComponent };